import { Link } from 'react-router-dom';

const seoArticles = [
  {
    slug: '/articolo/',
    title: 'Guida Completa Itaobuy Spreadsheet 2026',
    excerpt: 'Tutto ciò che devi sapere su Itaobuy Spreadsheet: funzionalità, strategie e consigli pratici per acquisti intelligenti.',
    image: 'https://readdy.ai/api/search-image?query=Organized%20desk%20workspace%20with%20laptop%20displaying%20spreadsheet%20data%20and%20fashion%20product%20images%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20modern%20home%20office%2C%20minimalist%20productivity%20aesthetic%2C%20relaxed%20creative%20atmosphere&width=600&height=400&seq=seo-card-01&orientation=landscape',
    tag: 'Guida 2026',
  },
  {
    slug: '/sicurezza/',
    title: 'Itaobuy Spreadsheet è Sicuro?',
    excerpt: 'Analisi completa della sicurezza: link verificati, QC photos e protezione dati per acquistare in totale tranquillità.',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20security%20concept%20with%20subtle%20padlock%20icon%20on%20soft%20beige%20background%2C%20minimal%20tech%20aesthetic%2C%20warm%20ambient%20lighting%2C%20trust%20and%20safety%20visualization%2C%20elegant%20corporate%20style%2C%20professional%20photography&width=600&height=400&seq=seo-card-02&orientation=landscape',
    tag: 'Sicurezza',
  },
  {
    slug: '/confronto/',
    title: 'Itaobuy Spreadsheet vs Alternative',
    excerpt: 'Confronto dettagliato con le principali alternative: caratteristiche, prezzi, sicurezza e esperienza utente a confronto.',
    image: 'https://readdy.ai/api/search-image?query=Two%20products%20side%20by%20side%20comparison%20concept%20on%20warm%20neutral%20desk%2C%20clean%20minimal%20composition%2C%20soft%20natural%20light%2C%20professional%20analytical%20aesthetic%2C%20organized%20comparison%20layout%2C%20sophisticated%20editorial%20style&width=600&height=400&seq=seo-card-03&orientation=landscape',
    tag: 'Confronto',
  },
  {
    slug: '/glossario/',
    title: 'Glossario dei Termini di Shopping Online',
    excerpt: 'Tutti i termini essenziali spiegati: shopping agent, product spreadsheet, QC photos e molto altro.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20dictionary%20or%20glossary%20book%20open%20on%20warm%20oatmeal%20desk%20surface%2C%20soft%20morning%20light%2C%20minimal%20academic%20aesthetic%2C%20organized%20knowledge%20concept%2C%20clean%20refined%20composition%2C%20warm%20intellectual%20atmosphere&width=600&height=400&seq=seo-card-04&orientation=landscape',
    tag: 'Glossario',
  },
  {
    slug: '/guida-acquisti/',
    title: 'Guida Acquisti: Come Comprare al Meglio',
    excerpt: 'Strategie avanzate per selezionare, confrontare e acquistare prodotti di qualità attraverso Itaobuy Sheet.',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20shopping%20bag%20with%20elegant%20fashion%20items%20peeking%20out%20on%20light%20cream%20surface%2C%20warm%20golden%20sunlight%2C%20sophisticated%20retail%20therapy%20concept%2C%20clean%20minimal%20composition%2C%20aspirational%20lifestyle%20photography%2C%20soft%20inviting%20atmosphere&width=600&height=400&seq=seo-card-05&orientation=landscape',
    tag: 'Guida Acquisti',
  },
  {
    slug: '/articolo/#errori',
    title: '7 Errori da Evitare negli Acquisti Online',
    excerpt: 'Gli errori più comuni che gli acquirenti commettono e come evitarli per fare sempre acquisti vincenti.',
    image: 'https://readdy.ai/api/search-image?query=Thoughtful%20person%20reviewing%20items%20on%20laptop%20with%20slight%20concerned%20expression%2C%20warm%20beige%20office%20background%2C%20soft%20natural%20window%20light%2C%20genuine%20candid%20moment%2C%20clean%20modern%20workspace%2C%20relatable%20lifestyle%20photography&width=600&height=400&seq=seo-card-06&orientation=landscape',
    tag: 'Consigli',
  },
  {
    slug: '/articolo/#come-funziona',
    title: 'Come Funziona Itaobuy Spreadsheet',
    excerpt: 'Guida passo passo al funzionamento della piattaforma: dalla ricerca prodotti al completamento dell\'ordine.',
    image: 'https://readdy.ai/api/search-image?query=Clean%20step%20by%20step%20workflow%20visualization%20on%20warm%20cream%20desk%20with%20laptop%2C%20notebook%20and%20organized%20materials%2C%20soft%20natural%20daylight%2C%20minimal%20tutorial%20concept%2C%20structured%20learning%20aesthetic%2C%20calm%20productive%20atmosphere&width=600&height=400&seq=seo-card-07&orientation=landscape',
    tag: 'Tutorial',
  },
  {
    slug: '/sicurezza/#qc-photos',
    title: 'QC Photos: Come Verificare la Qualità',
    excerpt: 'Le immagini di controllo qualità sono fondamentali: scopri come leggerle e interpretarle correttamente.',
    image: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20product%20detail%20photography%20on%20light%20sand%20surface%2C%20quality%20inspection%20concept%2C%20soft%20natural%20lighting%2C%20clean%20professional%20aesthetic%2C%20attention%20to%20detail%2C%20minimal%20investigative%20composition&width=600&height=400&seq=seo-card-08&orientation=landscape',
    tag: 'Qualità',
  },
  {
    slug: '/guida-acquisti/#strategie',
    title: 'Strategie Avanzate di Acquisto',
    excerpt: 'Tecniche e strategie per acquirenti esperti: acquisti stagionali, monitoraggio prezzi e acquisti in blocco.',
    image: 'https://readdy.ai/api/search-image?query=Strategic%20planning%20concept%20with%20organized%20notes%20and%20fashion%20lookbook%20on%20warm%20neutral%20desk%2C%20soft%20daylight%2C%20sophisticated%20creative%20workspace%2C%20intentional%20styling%2C%20calm%20focused%20atmosphere%2C%20editorial%20lifestyle%20aesthetic&width=600&height=400&seq=seo-card-09&orientation=landscape',
    tag: 'Strategie',
  },
];

export default function SEOArticlesGrid() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <div className="mb-6">
          <span className="text-xs font-medium text-accent-600 tracking-widest uppercase">
            Articoli SEO
          </span>
        </div>

        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950">
            Guide e Articoli<br />su Itaobuy Sheet
          </h2>
          <p className="text-foreground-500 text-sm max-w-md mt-3 md:mt-0">
            Contenuti originali in italiano per aiutarti a diventare un acquirente esperto
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <Link
              key={article.slug}
              to={article.slug}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-accent-200 transition-colors cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-2 whitespace-nowrap">
                  {article.tag}
                </span>
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2 leading-snug group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-1 mt-3 text-primary-500 text-xs font-medium">
                  Leggi articolo
                  <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}